import React, { forwardRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { formatDistanceStrict } from 'utils/datetime'
import { ewiIcons } from 'app/constants'
import { useIntl } from 'hooks'
import { notificationSelector, markRead } from 'features/bell-notification/notificationSlice'
import NotificationItem from 'components/Notifications/BellNotification'
import { ScrollableDirective } from 'components/Zui'
import './notification.css'

const Notification = (props, ref) => {
    const notifications = useSelector(state => notificationSelector.selectAll(state))
    const { isError } = useSelector(state => state.notifications)
    const { t } = useIntl()
    const dispatch = useDispatch()

    const handleMarkRead = id => {
        let payload = []
        if (id) payload = [id]
        else payload = notifications.filter(n => !n.isRead).map(n => n.id)

        payload.length && dispatch(markRead(payload))
    }

    const sorted = notifications.sort(
        (a, b) => new Date(b.updatedDateTime) - new Date(a.updatedDateTime)
    )

    return (
        <div className="bell-flyout-popup" ref={ref}>
            <div className="bellFlyout-header-wrapper">
                <div className="bellFlyout-header-title">
                    <span>{t('notifications')}</span>
                </div>
                <div className="bellFlyout-mark-all-read" onClick={() => handleMarkRead()}>
                    <span>{t('mark.all.as.read')}</span>
                </div>
            </div>
            <ScrollableDirective
                background="hidden"
                hitarea="enlarged"
                style={{ maxHeight: 'calc(100vh - 138px)' }}
            >
                {sorted?.map(notification => {
                    return (
                        <NotificationItem
                            key={notification.id}
                            id={notification.id}
                            title={notification.messageTitle}
                            timeStamp={formatDistanceStrict(notification.updatedDateTime) + ' ago'}
                            description={notification.messageBody}
                            icon={ewiIcons[notification.messageType]}
                            readStatus={notification.isRead}
                            handleMarkRead={handleMarkRead}
                        />
                    )
                })}
                {isError && (
                    <div style={{ width: '400px' }}>{t('fallback.error.notifications')}</div>
                )}
            </ScrollableDirective>
        </div>
    )
}

export default forwardRef(Notification)
